module.exports = function transformEmbedData(entity) {
	const code = entity.attributes.field_embed_code
		? entity.attributes.field_embed_code.replace(
				/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
				""
		  )
		: "";
	return {
		id: entity.id,
		type: entity.type,
		code,
		height: entity.attributes.field_embed_height,
	};
};
